import React from 'react';
import { connect } from 'react-redux';
import { RaisedButton, Dialog } from 'material-ui';
import _ from 'lodash';
import PublishDialogClean from '../../components/Form/PublishDialog';
import EditDialogClean from '../../components/Form/EditDialog';
import { deleteWithPagination, rejectWithPagination } from 'dash-front/campaign/actions/withPagination';
import { removeFromQuery } from 'dash-front/helpers';
import { getEntities } from 'dash-front/selectors';
import { withProps, compose } from 'recompose';

export const PublishDialog = connect(
    state => ({
        postId: _.get(state.routing, ['location', 'query', 'publish']),
    }),
    () => ({
        close: () => removeFromQuery('publish'),
    }),
)(PublishDialogClean);

export const EditDialog = connect(
    state => ({
        postId: _.get(state.routing, ['location', 'query', 'edit']),
    }),
    () => ({
        close: () => removeFromQuery('edit'),
    }),
)(EditDialogClean);

export const AbstractDialog = connect((state, { queryKey }) => ({
    queryValue: _.get(state.routing, ['location', 'query', queryKey]),
}))(({ queryKey, queryValue, okText = 'Yes', cancelText = 'Cancel', text = 'text here', okFn = _.noop }) => {
    const onClose = () => removeFromQuery(queryKey);
    return (
        <Dialog
            open={Boolean(queryValue)}
            className="no-padding-dialog"
            dialogContentStyle={{
                width: '90%',
                maxWidth: 'none',
            }}
            title={text}
            autoScrollBodyContent
            repositionOnUpdate
            autoDetectWindowHeight
            onRequestClose={onClose}
            modal={false}
        >
            <div>
                <RaisedButton
                    primary
                    label={okText}
                    onTouchTap={() => {
                        okFn(queryValue);
                        onClose();
                    }}
                    style={{ marginRight: 24 }}
                />
                <RaisedButton onTouchTap={onClose} secondary label={cancelText} />
            </div>
        </Dialog>
    );
});

export const RejectDialog = compose(
    connect(null),
    withProps(props => ({
        queryKey: 'reject',
        okText: 'Yes, reject',
        text: 'Are you sure to reject the post?',
        okFn: postId => props.dispatch(rejectWithPagination(postId)),
    })),
)(AbstractDialog);

export const DeleteDialog = compose(
    connect(null),
    withProps(props => ({
        queryKey: 'delete',
        okText: 'Yes, delete',
        text: 'Are you sure to delete the post and its results?',
        okFn: postId => props.dispatch(deleteWithPagination(postId)),
    })),
)(AbstractDialog);

export const LogsDialog = connect(state => {
    const queryValue = _.get(state.routing, ['location', 'query', 'logs']);
    const logs = _.get(getEntities(state).posts, [queryValue, 'logs']);
    return {
        queryValue,
        logs,
    };
})(({ queryValue, logs }) => {
    const onClose = () => removeFromQuery('logs');
    const text = Array.isArray(logs) ? logs.join('\n') : '';
    return (
        <Dialog
            open={Boolean(queryValue)}
            className="no-padding-dialog"
            dialogContentStyle={{
                width: '90%',
                maxWidth: 'none',
            }}
            title="Logs"
            autoScrollBodyContent
            repositionOnUpdate
            autoDetectWindowHeight
            onRequestClose={onClose}
            modal={false}
        >
            <div style={{ padding: 2 }}>
                <textarea value={text} cols={105} rows={50} />
            </div>
            <div>
                <RaisedButton secondary onTouchTap={onClose} label="Ok" />
            </div>
        </Dialog>
    );
});



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/dialogs.js
 **/